// extracted by css-extract-rspack-plugin
export default {"root":"TimeInput-module__root___DTGho","input":"TimeInput-module__input___WcEXn","error":"TimeInput-module__error___OBCEG"};